// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-page {
  background: #f7f7fb;
  min-height: 100vh;
}

.rc-shell {
  max-width: 1180px;
  margin: 0 auto;
  padding: 25px 14px 28px;
}

.rc-pill-title {
  background: #b31e8d;
  font-size: 26px;
  padding: 10px 22px;
  color: #fff;
  border-radius: 40px;
  position: absolute;
  bottom: -32px;
  box-shadow:
    0 8px 12px rgba(0,0,0,0.3),
    0 4px 6px rgba(0,0,0,0.2),
    inset 0 4px 6px rgba(255,255,255,0.3),
    inset 0 -4px 6px rgba(0,0,0,0.25);
}

.rc-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}

.rc-seg {
  display: inline-flex;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.rc-seg-btn {
  padding: 8px 14px;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-weight: 700;
  color: #6b7280;
  font-size: 13px;
}
.rc-seg-btn.active {
  background: #f3e8ff;
  color: #b31e8d;
}

.rc-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rc-btn {
  border: 0;
  padding: 9px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 800;
  background: #111827;
  color: #fff;
  font-size: 13px;
}
.rc-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.rc-btn-print {
  background: #b31e8d;
}

.rc-monthline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0 6px;
}

.rc-monthlabel {
  font-weight: 900;
  color: #111827;
  font-size: 18px;
}

.rc-nav {
  display: inline-flex;
  gap: 8px;
}

.rc-nav-btn {
  width: 34px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #0f172a;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.rc-left-controls{
  display:flex;
  align-items:center;
  gap:12px;
}

.rc-check{
  display:flex;
  align-items:center;
  gap:8px;
  font-weight:800;
  font-size:12px;
  color:#6b7280;
  background:#fff;
  border:1px solid #e5e7eb;
  padding:7px 10px;
  border-radius:10px;
}
.rc-check input{
  width:16px;
  height:16px;
  accent-color:#b31e8d;
}

.rc-cal-wrap {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #edf0f5;
  box-shadow: 0 10px 22px rgba(0,0,0,0.06);
}

.rbc-toolbar {
  display: none;
}
.rbc-month-view,
.rbc-time-view {
  border: 0;
}

.rbc-header {
  padding: 10px 8px !important;
  font-weight: 800;
  font-size: 16px;
  color: #646568;
  border-bottom: 1px solid #f1f5f9 !important;
}

.rbc-month-row,
.rbc-time-content,
.rbc-time-header-content {
  border-color: #f1f5f9 !important;
}

.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #f1f5f9 !important;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #f1f5f9 !important;
}

.rc-day-picker {
  font-size: 13px;
}

.rbc-date-cell {
  padding: 8px 10px !important;
  color: #111827;
  font-weight: 900;
  font-size: 12px;
}

.rc-day-outside .rbc-date-cell {
  opacity: 0.35;
}
.rc-day-today {
  background: rgba(179,30,141,0.05);
}

.rbc-month-view .rbc-event:has(.rc-event-timeonly) {
  height: auto !important;
  overflow: visible !important;
}

.rbc-month-view .rbc-event:has(.rc-event-timeonly) .rbc-event-content {
  overflow: visible !important;
}

.rbc-event .rc-event-inner.rc-event-timeonly .rc-event-time {
  display: flex !important;
  flex-direction: column !important;  
  white-space: normal !important;     
  line-height: 1.1 !important;
  padding: 4px 12px !important;     
}

.rbc-event .rc-event-inner.rc-event-timeonly .rc-event-time .rc-sub {
  font-size: 10px;
  font-weight: 700;
  opacity: 0.95;
}

/* .rbc-month-view .rbc-month-row {
  height: 92px !important;       
  overflow: hidden !important;
} */

.rbc-month-view .rbc-row-content {
  height: 100% !important;
}

/* .rbc-month-view .rbc-row-segment {
  height: 22px !important;
  max-height: 22px !important;
  overflow: hidden !important;
} */

.rbc-month-view .rbc-event {
  border: 0 !important;
  border-radius: 8px !important;
  height: 20px !important;
  padding: 2px 6px !important;
  line-height: 16px !important;
  box-shadow: none !important;

  background: rgba(59, 130, 246, 0.3) !important;
  color: #1d4ed8 !important;

  overflow: hidden !important;
}

.rbc-month-view .rbc-event-content,
.rc-event-inner,
.rc-event-room,
.rc-event-title,
.rc-event-time {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.rbc-month-view .rbc-show-more {
  display: inline-block !important;
  font-size: 11px !important;
  font-weight: 900 !important;
  color: #b31e8d !important;
  padding-left: 6px !important;
  margin-top: 2px !important;
}

.rc-event-inner {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rc-event-top {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: baseline;
}

.rc-event-room {
  font-weight: 900;
  font-size: 10.5px;
}

.rc-event-time {
  opacity: 0.9;
  font-size: 10px;
}

.rc-event-title {
  font-size: 10.5px;
  font-weight: 800;
}

.rc-empty {
  margin-top: 12px;
  background: #fff;
  border: 1px solid #edf0f5;
  border-radius: 14px;
  padding: 12px 14px;
  color: #6b7280;
  font-weight: 800;
  font-size: 12px;
}

.rc-weekgrid {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #eef2f7;
  overflow: visible;
}

.rc-weekgrid-head {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: #fafbff;
  border-bottom: 1px solid #eef2f7;
}

.rc-weekgrid-colhead {
  padding: 10px 10px;
  border-right: 1px solid #eef2f7;
}
.rc-weekgrid-colhead:last-child {
  border-right: 0;
}

.rc-weekgrid-colhead-inner {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
}

.rc-weekgrid-date {
  font-weight: 900;
  color: #111827;
  font-size: 13px;
}

.rc-weekgrid-dow {
  font-weight: 800;
  color: #6b7280;
  font-size: 11px;
}

.rc-weekgrid-body {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 10px;
  align-items: stretch;      
}

.rc-weekgrid-day {
  padding: 10px;
  border-right: 1px solid #eef2f7;
  border-bottom: 1px solid #eef2f7;
  background: #fff;
}
.rc-weekgrid-day:last-child {
  border-right: 0;
}

.rc-weekgrid-today {
  background: #fff7fb;
}

.rc-weekgrid-empty {
  color: #9ca3af;
  font-weight: 800;
  font-size: 11px;
  padding-top: 4px;
}

.rc-week-item {
  border-radius: 12px;
  padding: 9px 10px;
  margin-bottom: 8px;
  background: #eef4ff;
  border: 1px solid #dbeafe;
}

.rc-week-item-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.rc-week-item-room {
  font-size: 11px;
  font-weight: 900;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rc-week-item-time {
  font-weight: 800;
  color: #9c085e;
  font-size: 10.5px;
  opacity: 0.9;
  white-space: nowrap;
}

.rc-room-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 8px 16px;
  border-radius: 999px;

  border: 1px solid #e3e3e3;
  background: linear-gradient(135deg, #ffffff, #f7f9fc);
  color: #333;

  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}

.rc-room-btn:hover {
  background: linear-gradient(135deg, #f1f5ff, #e8efff);
  border-color: #c9d6ff;
  color: #b31e8d;
  transform: translateY(-1px);
}

.rc-room-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}


.rc-week-item-title {
  font-weight: 900;
  color: #0f172a;
  font-size: 11px;
  line-height: 1.2;
}

.rc-event-timeonly {
  opacity: 0.95;
}

.rc-week-item-timeonly {
  background: #f3e8ff;
  border: 1px solid #e9d5ff;
}

.rv-wrap { display:flex; flex-direction:column; gap:16px; }
  .rv-room-block { background:#fff; border-radius:12px; overflow:hidden; border:1px solid #e9e9e9; }
  .rv-table { width:100%; border-collapse:collapse; table-layout:fixed; }
  .rv-th, .rv-td { border:1px solid #222; vertical-align:top; padding:8px; font-size:13px; }
  .rv-th { background:#c9d7e6; text-align:center; font-weight:700; color: #222; }
  .rv-th-time { width:160px; background:#2e2e2d; color: #fff !important;}
  .rv-th-room { width:90px; background:#ffe600; }
  .rv-td-time { font-weight:700; text-align:center;color: #222; }
  .slot-1 { background:#fff6c7; }
  .slot-2 { background:#dfeac8; }
  .slot-3 { background:#ffbf00; }
  .slot-4 { background:#b8b7b7; }
  .rv-td-room { background:#fff; }
  .rv-td-day { background:#fff; min-height:80px; }
  .rv-cell-stack { display:flex; flex-direction:column; gap:6px; }
  .rv-ev-title { font-weight:700; font-size:12px; line-height:1.2; color: #0f172a; }
  .rv-ev-time { font-size:11px; opacity:.85; margin-top:2px;color: #0f172a; }

@media print {
  .rc-no-print { display: none !important; }
  .rc-shell { padding-top: 10px !important; }
  .rc-cal-wrap { box-shadow: none !important; border: 1px solid #ddd !important; }
}

.rc-print-only { display: none; }

.rc-zone-badge{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  font-weight:700;
  font-size:12px;
  padding:2px 10px;
  border-radius:999px;
  letter-spacing:.3px;
}

.rbc-event:has(.rc-event-timeonly) {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.rbc-event-content {
  background: transparent !important;
}

.rc-event-inner.rc-event-timeonly {
  background: transparent !important;
}

.rbc-event .rc-event-inner.rc-event-timeonly.rc-zone-green .rc-event-time {
  background-color: #2AA63E !important;
  color: #ffffff !important;
  border-radius: 999px;
  padding: 3px 12px;
  font-weight: 800;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  line-height: 1;
}

.rbc-event .rc-event-inner.rc-event-timeonly.rc-zone-red .rc-event-time {
  background-color: #ff3b30 !important;
  color: #ffffff !important;
  border-radius: 999px;
  padding: 3px 12px;
  font-weight: 800;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  line-height: 1;
}

.rc-event-inner.rc-event-timeonly .rc-event-top {
  display: flex;
  justify-content: center;
}

/* =========================
   PRINT / VIEW LEGEND
========================= */

.rc-print-legend{
  display: flex;
  gap: 14px;
  margin-top: 6px;
  align-items: center;
  flex-wrap: wrap;
}

.rc-legend-item{
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #222;
}

.rc-legend-pill{
  width: 28px;
  height: 14px;
  border-radius: 999px;
  display: inline-block;
}

/* zone colors */
.rc-legend-pill.rc-zone-green{
  background: #1db954;
}

.rc-legend-pill.rc-zone-red{
  background: #ff3b30;
}

/* print-safe */
@media print{
  .rc-print-legend{
    margin-top: 4px;
  }
}

@media print {
  @page { size: A4 landscape; margin: 6mm; }

  html, body {
    height: auto !important;
    overflow: hidden !important;
    print-color-adjust: exact !important;
  }

  .rc-no-print,
  .mgmt-header,
  .rc-monthline,
  .rc-topbar,
  .rc-actions,
  .rc-nav,
  .rc-empty {
    display: none !important;
  }

  .mgmt-wrap, .rc-page, .rc-shell {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    background-image: none !important;
  }

  .rc-print-only { display: block !important; }

  .rc-print-meta {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: 4mm 4mm 3mm 4mm;
    border-radius: 8px;
    margin-bottom: 3mm;
  }

  .rc-print-month {
    font-size: 18px;
    font-weight: 800;
    color: black;
    text-transform: uppercase;
  }

  .rc-print-date {
    font-size: 10px;
    color: black;
  }


  .rc-cal-wrap {
    height: 175mm !important;
    overflow: hidden !important;
  }

  .rbc-calendar {
    height: 175mm !important;
    min-height: 175mm !important;
    padding: 30px;
  }

  .rbc-month-view {
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  .rbc-month-header { flex: 0 0 auto !important; }
  .rbc-month-row { flex: 1 1 !important; min-height: 0 !important; }
  .rbc-row-content { height: 100% !important; }

  .rbc-header { font-size: 11px !important; padding: 4px 0 !important; }
  .rbc-date-cell { font-size: 10px !important; }
  .rbc-event { font-size: 9px !important; padding: 1px 3px !important; }
  .rbc-event-content { font-size: 9px !important; }

  .rc-cal-wrap, .rbc-calendar, .rbc-month-view {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}

/* PDF capture wrapper */
.rc-pdf-area {
  background: #fff;
  padding: 10px;
}

/* header shown inside PDF */
.rc-print-meta {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 10px 12px;
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 10px;
  margin-bottom: 10px;
}

.rc-daylist {
  border: 1px solid rgba(0,0,0,.08);
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
}

.rc-daylist-head {
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0,0,0,.08);
  background: #f7f8fb;
  color:black;
}

.rc-center{
  display: block;
  width: 100%;
  text-align: center;
}

.rc-daylist-today {
  background: #eef6ff;
}

.rc-daylist-title {
  font-weight: 800;
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.rc-daylist-date {
  font-weight: 600;
  opacity: 0.75;
  font-size: 0.95rem;
}

.rc-daylist-body {
  padding: 12px;
}

.rc-calendar-readonly,
.rc-calendar-readonly * {
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}

.rc-more-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.rc-more-modal {
  width: min(720px, 92vw);
  max-height: 80vh;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.rc-more-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0,0,0,.08);
  background: #f7f8fb;
  color: black;
}

.rc-more-title {
  font-weight: 800;
}

.rc-more-close {
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 10px;
}

.rc-more-close:hover {
  background: rgba(0,0,0,.06);
}

.rc-more-body {
  padding: 12px;
  overflow: auto;
}

/* Room header: show room + pax under it */
.rv-room-head{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  gap:2px;
  line-height:1.1;
}

.rv-room-name{
  font-weight:800;
  font-size:14px;
}

.rv-room-pax{
  font-size:12px;
  font-weight:700;
  opacity:.9;
}

/* The printable/PDF area should be positioning context */
.rc-pdf-area {
  position: relative;
}

/* Hidden on screen */
.rc-print-footer-logo {
  display: none;
}

.rc-fab{
  position: fixed;
  right: 22px;
  bottom: 22px;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #b022a2; /* EAIM pink */
  color: #fff;
  box-shadow: 0 10px 22px rgba(0,0,0,.25);
}

.rc-fab:hover{
  transform: translateY(-2px);
}

.rc-fab:active{
  transform: translateY(0px);
}


/* Show ONLY when printing (window.print) */
@media print {
  .rc-print-footer-logo {
    display: block;
    position: fixed;
    right: 10mm;
    bottom: 8mm;
    z-index: 9999;
    opacity: 0.95;
  }

  .rc-print-footer-logo img {
    height: 14mm; /* adjust size */
    width: auto;
    object-fit: contain;
  }
}






`, "",{"version":3,"sources":["webpack://./src/Components/roomCalendar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb;;;;qCAImC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,cAAc;EACd,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;AACA;;EAEE,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;GAGG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;;;;GAIG;;AAEH;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;;EAE3B,8CAA8C;EAC9C,yBAAyB;;EAEzB,2BAA2B;AAC7B;;AAEA;;;;;EAKE,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER,iBAAiB;EACjB,oBAAoB;;EAEpB,yBAAyB;EACzB,qDAAqD;EACrD,WAAW;;EAEX,eAAe;EACf,gBAAgB;EAChB,eAAe;;EAEf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,WAAW,YAAY,EAAE,qBAAqB,EAAE,QAAQ,EAAE;EACxD,iBAAiB,eAAe,EAAE,kBAAkB,EAAE,eAAe,EAAE,wBAAwB,EAAE;EACjG,YAAY,UAAU,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;EACtE,iBAAiB,qBAAqB,EAAE,kBAAkB,EAAE,WAAW,EAAE,cAAc,EAAE;EACzF,SAAS,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,WAAW,EAAE;EAC9E,cAAc,WAAW,EAAE,kBAAkB,EAAE,sBAAsB,CAAC;EACtE,cAAc,UAAU,EAAE,kBAAkB,EAAE;EAC9C,cAAc,eAAe,EAAE,iBAAiB,CAAC,WAAW,EAAE;EAC9D,UAAU,kBAAkB,EAAE;EAC9B,UAAU,kBAAkB,EAAE;EAC9B,UAAU,kBAAkB,EAAE;EAC9B,UAAU,kBAAkB,EAAE;EAC9B,cAAc,eAAe,EAAE;EAC/B,aAAa,eAAe,EAAE,eAAe,EAAE;EAC/C,iBAAiB,YAAY,EAAE,qBAAqB,EAAE,OAAO,EAAE;EAC/D,eAAe,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;EACjF,cAAc,cAAc,EAAE,WAAW,EAAE,cAAc,CAAC,cAAc,EAAE;;AAE5E;EACE,eAAe,wBAAwB,EAAE;EACzC,YAAY,4BAA4B,EAAE;EAC1C,eAAe,2BAA2B,EAAE,iCAAiC,EAAE;AACjF;;AAEA,iBAAiB,aAAa,EAAE;;AAEhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,QAAQ,kBAAkB,EAAE,WAAW,EAAE;;EAEzC;IACE,uBAAuB;IACvB,2BAA2B;IAE3B,oCAAoC;EACtC;;EAEA;;;;;;;IAOE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA,iBAAiB,yBAAyB,EAAE;;EAE5C;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;;EAGA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,iCAAiC;EACnC;EACA,oBAAoB,yBAAyB,EAAE;EAC/C,iBAAiB,oBAAsB,EAAE,wBAAwB,EAAE;EACnE,mBAAmB,uBAAuB,EAAE;;EAE5C,cAAc,0BAA0B,EAAE,yBAAyB,EAAE;EACrE,iBAAiB,0BAA0B,EAAE;EAC7C,aAAa,yBAAyB,EAAE,2BAA2B,EAAE;EACrE,qBAAqB,yBAAyB,EAAE;;EAEhD;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,aAAa;;EAEb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB,EAAE,cAAc;EACnC,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA,2CAA2C;AAC3C;EACE;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,WAAW;IACX,aAAa;IACb,aAAa;EACf;;EAEA;IACE,YAAY,EAAE,gBAAgB;IAC9B,WAAW;IACX,mBAAmB;EACrB;AACF","sourcesContent":[".rc-page {\n  background: #f7f7fb;\n  min-height: 100vh;\n}\n\n.rc-shell {\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 25px 14px 28px;\n}\n\n.rc-pill-title {\n  background: #b31e8d;\n  font-size: 26px;\n  padding: 10px 22px;\n  color: #fff;\n  border-radius: 40px;\n  position: absolute;\n  bottom: -32px;\n  box-shadow:\n    0 8px 12px rgba(0,0,0,0.3),\n    0 4px 6px rgba(0,0,0,0.2),\n    inset 0 4px 6px rgba(255,255,255,0.3),\n    inset 0 -4px 6px rgba(0,0,0,0.25);\n}\n\n.rc-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n.rc-seg {\n  display: inline-flex;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.rc-seg-btn {\n  padding: 8px 14px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-weight: 700;\n  color: #6b7280;\n  font-size: 13px;\n}\n.rc-seg-btn.active {\n  background: #f3e8ff;\n  color: #b31e8d;\n}\n\n.rc-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rc-btn {\n  border: 0;\n  padding: 9px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 800;\n  background: #111827;\n  color: #fff;\n  font-size: 13px;\n}\n.rc-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n.rc-btn-print {\n  background: #b31e8d;\n}\n\n.rc-monthline {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 6px 0 6px;\n}\n\n.rc-monthlabel {\n  font-weight: 900;\n  color: #111827;\n  font-size: 18px;\n}\n\n.rc-nav {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.rc-nav-btn {\n  width: 34px;\n  height: 30px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #0f172a;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n}\n\n.rc-left-controls{\n  display:flex;\n  align-items:center;\n  gap:12px;\n}\n\n.rc-check{\n  display:flex;\n  align-items:center;\n  gap:8px;\n  font-weight:800;\n  font-size:12px;\n  color:#6b7280;\n  background:#fff;\n  border:1px solid #e5e7eb;\n  padding:7px 10px;\n  border-radius:10px;\n}\n.rc-check input{\n  width:16px;\n  height:16px;\n  accent-color:#b31e8d;\n}\n\n.rc-cal-wrap {\n  background: #fff;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid #edf0f5;\n  box-shadow: 0 10px 22px rgba(0,0,0,0.06);\n}\n\n.rbc-toolbar {\n  display: none;\n}\n.rbc-month-view,\n.rbc-time-view {\n  border: 0;\n}\n\n.rbc-header {\n  padding: 10px 8px !important;\n  font-weight: 800;\n  font-size: 16px;\n  color: #646568;\n  border-bottom: 1px solid #f1f5f9 !important;\n}\n\n.rbc-month-row,\n.rbc-time-content,\n.rbc-time-header-content {\n  border-color: #f1f5f9 !important;\n}\n\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #f1f5f9 !important;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #f1f5f9 !important;\n}\n\n.rc-day-picker {\n  font-size: 13px;\n}\n\n.rbc-date-cell {\n  padding: 8px 10px !important;\n  color: #111827;\n  font-weight: 900;\n  font-size: 12px;\n}\n\n.rc-day-outside .rbc-date-cell {\n  opacity: 0.35;\n}\n.rc-day-today {\n  background: rgba(179,30,141,0.05);\n}\n\n.rbc-month-view .rbc-event:has(.rc-event-timeonly) {\n  height: auto !important;\n  overflow: visible !important;\n}\n\n.rbc-month-view .rbc-event:has(.rc-event-timeonly) .rbc-event-content {\n  overflow: visible !important;\n}\n\n.rbc-event .rc-event-inner.rc-event-timeonly .rc-event-time {\n  display: flex !important;\n  flex-direction: column !important;  \n  white-space: normal !important;     \n  line-height: 1.1 !important;\n  padding: 4px 12px !important;     \n}\n\n.rbc-event .rc-event-inner.rc-event-timeonly .rc-event-time .rc-sub {\n  font-size: 10px;\n  font-weight: 700;\n  opacity: 0.95;\n}\n\n/* .rbc-month-view .rbc-month-row {\n  height: 92px !important;       \n  overflow: hidden !important;\n} */\n\n.rbc-month-view .rbc-row-content {\n  height: 100% !important;\n}\n\n/* .rbc-month-view .rbc-row-segment {\n  height: 22px !important;\n  max-height: 22px !important;\n  overflow: hidden !important;\n} */\n\n.rbc-month-view .rbc-event {\n  border: 0 !important;\n  border-radius: 8px !important;\n  height: 20px !important;\n  padding: 2px 6px !important;\n  line-height: 16px !important;\n  box-shadow: none !important;\n\n  background: rgba(59, 130, 246, 0.3) !important;\n  color: #1d4ed8 !important;\n\n  overflow: hidden !important;\n}\n\n.rbc-month-view .rbc-event-content,\n.rc-event-inner,\n.rc-event-room,\n.rc-event-title,\n.rc-event-time {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.rbc-month-view .rbc-show-more {\n  display: inline-block !important;\n  font-size: 11px !important;\n  font-weight: 900 !important;\n  color: #b31e8d !important;\n  padding-left: 6px !important;\n  margin-top: 2px !important;\n}\n\n.rc-event-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.rc-event-top {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: baseline;\n}\n\n.rc-event-room {\n  font-weight: 900;\n  font-size: 10.5px;\n}\n\n.rc-event-time {\n  opacity: 0.9;\n  font-size: 10px;\n}\n\n.rc-event-title {\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.rc-empty {\n  margin-top: 12px;\n  background: #fff;\n  border: 1px solid #edf0f5;\n  border-radius: 14px;\n  padding: 12px 14px;\n  color: #6b7280;\n  font-weight: 800;\n  font-size: 12px;\n}\n\n.rc-weekgrid {\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #eef2f7;\n  overflow: visible;\n}\n\n.rc-weekgrid-head {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  background: #fafbff;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.rc-weekgrid-colhead {\n  padding: 10px 10px;\n  border-right: 1px solid #eef2f7;\n}\n.rc-weekgrid-colhead:last-child {\n  border-right: 0;\n}\n\n.rc-weekgrid-colhead-inner {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 6px;\n}\n\n.rc-weekgrid-date {\n  font-weight: 900;\n  color: #111827;\n  font-size: 13px;\n}\n\n.rc-weekgrid-dow {\n  font-weight: 800;\n  color: #6b7280;\n  font-size: 11px;\n}\n\n.rc-weekgrid-body {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 10px;\n  align-items: stretch;      \n}\n\n.rc-weekgrid-day {\n  padding: 10px;\n  border-right: 1px solid #eef2f7;\n  border-bottom: 1px solid #eef2f7;\n  background: #fff;\n}\n.rc-weekgrid-day:last-child {\n  border-right: 0;\n}\n\n.rc-weekgrid-today {\n  background: #fff7fb;\n}\n\n.rc-weekgrid-empty {\n  color: #9ca3af;\n  font-weight: 800;\n  font-size: 11px;\n  padding-top: 4px;\n}\n\n.rc-week-item {\n  border-radius: 12px;\n  padding: 9px 10px;\n  margin-bottom: 8px;\n  background: #eef4ff;\n  border: 1px solid #dbeafe;\n}\n\n.rc-week-item-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.rc-week-item-room {\n  font-size: 11px;\n  font-weight: 900;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rc-week-item-time {\n  font-weight: 800;\n  color: #9c085e;\n  font-size: 10.5px;\n  opacity: 0.9;\n  white-space: nowrap;\n}\n\n.rc-room-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n\n  padding: 8px 16px;\n  border-radius: 999px;\n\n  border: 1px solid #e3e3e3;\n  background: linear-gradient(135deg, #ffffff, #f7f9fc);\n  color: #333;\n\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  transition: all 0.2s ease;\n}\n\n.rc-room-btn:hover {\n  background: linear-gradient(135deg, #f1f5ff, #e8efff);\n  border-color: #c9d6ff;\n  color: #b31e8d;\n  transform: translateY(-1px);\n}\n\n.rc-room-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n\n.rc-week-item-title {\n  font-weight: 900;\n  color: #0f172a;\n  font-size: 11px;\n  line-height: 1.2;\n}\n\n.rc-event-timeonly {\n  opacity: 0.95;\n}\n\n.rc-week-item-timeonly {\n  background: #f3e8ff;\n  border: 1px solid #e9d5ff;\n}\n\n.rv-wrap { display:flex; flex-direction:column; gap:16px; }\n  .rv-room-block { background:#fff; border-radius:12px; overflow:hidden; border:1px solid #e9e9e9; }\n  .rv-table { width:100%; border-collapse:collapse; table-layout:fixed; }\n  .rv-th, .rv-td { border:1px solid #222; vertical-align:top; padding:8px; font-size:13px; }\n  .rv-th { background:#c9d7e6; text-align:center; font-weight:700; color: #222; }\n  .rv-th-time { width:160px; background:#2e2e2d; color: #fff !important;}\n  .rv-th-room { width:90px; background:#ffe600; }\n  .rv-td-time { font-weight:700; text-align:center;color: #222; }\n  .slot-1 { background:#fff6c7; }\n  .slot-2 { background:#dfeac8; }\n  .slot-3 { background:#ffbf00; }\n  .slot-4 { background:#b8b7b7; }\n  .rv-td-room { background:#fff; }\n  .rv-td-day { background:#fff; min-height:80px; }\n  .rv-cell-stack { display:flex; flex-direction:column; gap:6px; }\n  .rv-ev-title { font-weight:700; font-size:12px; line-height:1.2; color: #0f172a; }\n  .rv-ev-time { font-size:11px; opacity:.85; margin-top:2px;color: #0f172a; }\n\n@media print {\n  .rc-no-print { display: none !important; }\n  .rc-shell { padding-top: 10px !important; }\n  .rc-cal-wrap { box-shadow: none !important; border: 1px solid #ddd !important; }\n}\n\n.rc-print-only { display: none; }\n\n.rc-zone-badge{\n  display:inline-flex;\n  align-items:center;\n  justify-content:center;\n  font-weight:700;\n  font-size:12px;\n  padding:2px 10px;\n  border-radius:999px;\n  letter-spacing:.3px;\n}\n\n.rbc-event:has(.rc-event-timeonly) {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n\n.rbc-event-content {\n  background: transparent !important;\n}\n\n.rc-event-inner.rc-event-timeonly {\n  background: transparent !important;\n}\n\n.rbc-event .rc-event-inner.rc-event-timeonly.rc-zone-green .rc-event-time {\n  background-color: #2AA63E !important;\n  color: #ffffff !important;\n  border-radius: 999px;\n  padding: 3px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.rbc-event .rc-event-inner.rc-event-timeonly.rc-zone-red .rc-event-time {\n  background-color: #ff3b30 !important;\n  color: #ffffff !important;\n  border-radius: 999px;\n  padding: 3px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.rc-event-inner.rc-event-timeonly .rc-event-top {\n  display: flex;\n  justify-content: center;\n}\n\n/* =========================\n   PRINT / VIEW LEGEND\n========================= */\n\n.rc-print-legend{\n  display: flex;\n  gap: 14px;\n  margin-top: 6px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.rc-legend-item{\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #222;\n}\n\n.rc-legend-pill{\n  width: 28px;\n  height: 14px;\n  border-radius: 999px;\n  display: inline-block;\n}\n\n/* zone colors */\n.rc-legend-pill.rc-zone-green{\n  background: #1db954;\n}\n\n.rc-legend-pill.rc-zone-red{\n  background: #ff3b30;\n}\n\n/* print-safe */\n@media print{\n  .rc-print-legend{\n    margin-top: 4px;\n  }\n}\n\n@media print {\n  @page { size: A4 landscape; margin: 6mm; }\n\n  html, body {\n    height: auto !important;\n    overflow: hidden !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  .rc-no-print,\n  .mgmt-header,\n  .rc-monthline,\n  .rc-topbar,\n  .rc-actions,\n  .rc-nav,\n  .rc-empty {\n    display: none !important;\n  }\n\n  .mgmt-wrap, .rc-page, .rc-shell {\n    margin: 0 !important;\n    padding: 0 !important;\n    background: #fff !important;\n    background-image: none !important;\n  }\n\n  .rc-print-only { display: block !important; }\n\n  .rc-print-meta {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    padding: 4mm 4mm 3mm 4mm;\n    border-radius: 8px;\n    margin-bottom: 3mm;\n  }\n\n  .rc-print-month {\n    font-size: 18px;\n    font-weight: 800;\n    color: black;\n    text-transform: uppercase;\n  }\n\n  .rc-print-date {\n    font-size: 10px;\n    color: black;\n  }\n\n\n  .rc-cal-wrap {\n    height: 175mm !important;\n    overflow: hidden !important;\n  }\n\n  .rbc-calendar {\n    height: 175mm !important;\n    min-height: 175mm !important;\n    padding: 30px;\n  }\n\n  .rbc-month-view {\n    height: 100% !important;\n    display: flex !important;\n    flex-direction: column !important;\n  }\n  .rbc-month-header { flex: 0 0 auto !important; }\n  .rbc-month-row { flex: 1 1 0 !important; min-height: 0 !important; }\n  .rbc-row-content { height: 100% !important; }\n\n  .rbc-header { font-size: 11px !important; padding: 4px 0 !important; }\n  .rbc-date-cell { font-size: 10px !important; }\n  .rbc-event { font-size: 9px !important; padding: 1px 3px !important; }\n  .rbc-event-content { font-size: 9px !important; }\n\n  .rc-cal-wrap, .rbc-calendar, .rbc-month-view {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n}\n\n/* PDF capture wrapper */\n.rc-pdf-area {\n  background: #fff;\n  padding: 10px;\n}\n\n/* header shown inside PDF */\n.rc-print-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  padding: 10px 12px;\n  border: 1px solid rgba(0,0,0,0.12);\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.rc-daylist {\n  border: 1px solid rgba(0,0,0,.08);\n  border-radius: 14px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.rc-daylist-head {\n  padding: 14px 16px;\n  border-bottom: 1px solid rgba(0,0,0,.08);\n  background: #f7f8fb;\n  color:black;\n}\n\n.rc-center{\n  display: block;\n  width: 100%;\n  text-align: center;\n}\n\n.rc-daylist-today {\n  background: #eef6ff;\n}\n\n.rc-daylist-title {\n  font-weight: 800;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n\n.rc-daylist-date {\n  font-weight: 600;\n  opacity: 0.75;\n  font-size: 0.95rem;\n}\n\n.rc-daylist-body {\n  padding: 12px;\n}\n\n.rc-calendar-readonly,\n.rc-calendar-readonly * {\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n.rc-more-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.rc-more-modal {\n  width: min(720px, 92vw);\n  max-height: 80vh;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0,0,0,.25);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.rc-more-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid rgba(0,0,0,.08);\n  background: #f7f8fb;\n  color: black;\n}\n\n.rc-more-title {\n  font-weight: 800;\n}\n\n.rc-more-close {\n  border: none;\n  background: transparent;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: 10px;\n}\n\n.rc-more-close:hover {\n  background: rgba(0,0,0,.06);\n}\n\n.rc-more-body {\n  padding: 12px;\n  overflow: auto;\n}\n\n/* Room header: show room + pax under it */\n.rv-room-head{\n  display:flex;\n  flex-direction:column;\n  align-items:center;\n  justify-content:center;\n  gap:2px;\n  line-height:1.1;\n}\n\n.rv-room-name{\n  font-weight:800;\n  font-size:14px;\n}\n\n.rv-room-pax{\n  font-size:12px;\n  font-weight:700;\n  opacity:.9;\n}\n\n/* The printable/PDF area should be positioning context */\n.rc-pdf-area {\n  position: relative;\n}\n\n/* Hidden on screen */\n.rc-print-footer-logo {\n  display: none;\n}\n\n.rc-fab{\n  position: fixed;\n  right: 22px;\n  bottom: 22px;\n  width: 56px;\n  height: 56px;\n  border-radius: 999px;\n  border: none;\n  cursor: pointer;\n  z-index: 9999;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: #b022a2; /* EAIM pink */\n  color: #fff;\n  box-shadow: 0 10px 22px rgba(0,0,0,.25);\n}\n\n.rc-fab:hover{\n  transform: translateY(-2px);\n}\n\n.rc-fab:active{\n  transform: translateY(0px);\n}\n\n\n/* Show ONLY when printing (window.print) */\n@media print {\n  .rc-print-footer-logo {\n    display: block;\n    position: fixed;\n    right: 10mm;\n    bottom: 8mm;\n    z-index: 9999;\n    opacity: 0.95;\n  }\n\n  .rc-print-footer-logo img {\n    height: 14mm; /* adjust size */\n    width: auto;\n    object-fit: contain;\n  }\n}\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
